<template>
  <ak-tooltip
    v-if="section === 'icon'"
    :class="status.outerClasses"
    placement="bottom-end"
    theme="light"
  >
    <template #trigger>
      <ak-icon :class="status.innerClasses"></ak-icon>
    </template>
    {{ status.description }}
  </ak-tooltip>
  <div v-if="section === 'name'" class="text-nowrap ml-tiny">
    {{ status.name }}
  </div>
</template>

<script>
import { defineComponent, watch } from 'vue'
import Tooltip from '@akerolabs/akero-vue/src/components/tooltip/Tooltip.vue'
import { accountObj } from '@akerolabs/akero-vue/src/store'

export default defineComponent({
  name: 'AkTacticPartStatus',

  components: {
    [Tooltip.name]: Tooltip,
  },
  props: {
    tacticSection: {
      default: () => ({}),
      type: Object,
    },
    agencyUser: {
      default: '',
      type: String,
    },
    section: {
      default: '',
      type: String,
    },
  },
  setup(props) {
    let addons = props.tacticSection ? props.tacticSection.addons : undefined
    let hasAddons =
      props.tacticSection && addons && Object.keys(addons).length ? true : false

    const getStatus = (tactic, agencyUser) => {
      const alertOuter = 'flex circle circle--status-icons bg-warning'
      const alertInner = 'icon-alert color-white circle--font-small'
      const editInner = 'icon-edit color-white circle--font-small'
      const inProgressOuter =
        'flex circle circle--status-icons bg-primary-light'
      const inProgressInner = 'icon-time circle--font-medium color-grey'
      const completeOuter = 'flex circle circle--status-icons bg-success'
      const completeInner = 'icon-checkmark circle--font-small color-white'
      const statusObj = {
        description: 'Incomplete',
        outerClasses: 'flex circle circle--status-icons bg-grey-lighter',
        innerClasses: 'icon-checkmark color-white circle--font-small',
        name: accountObj().name || '',
      }

      if (hasAddons) {
        if (
          (tactic.stage === 'not_submitted' &&
            addons.copywriting &&
            addons.copywriting.stage === 'not_submitted') ||
          (addons.lite_motion &&
            addons.lite_motion.stage === 'not_submitted') ||
          (addons.creative && addons.creative.stage === 'not_submitted')
        ) {
          if (agencyUser) {
            statusObj.description =
              'Client needs to complete Creative Service brief'
            statusObj.innerClasses = inProgressInner
            statusObj.outerClasses = inProgressOuter
            statusObj.name = accountObj().name
          } else {
            statusObj.description =
              "You've purchased a creative service, but the brief still needs completing"
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = alertInner
            statusObj.name = accountObj().name
          }
        } else if (
          tactic.stage === 'not_submitted' &&
          !tactic.rejectionCount &&
          ((addons.copywriting && addons.copywriting.stage === 'submitted') ||
            (addons.lite_motion && addons.lite_motion.stage === 'submitted') ||
            (addons.creative && addons.creative.stage === 'submitted'))
        ) {
          if (agencyUser) {
            statusObj.description = 'Creative Service needs completing'
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = alertInner
            statusObj.name = 'Natives'
          } else {
            statusObj.description = 'An expert is working on this'
            statusObj.outerClasses = inProgressOuter
            statusObj.innerClasses = inProgressInner
            statusObj.name = 'Natives'
          }
        } else if (
          tactic.stage === 'not_submitted' &&
          tactic.rejectionCount &&
          ((addons.copywriting && addons.copywriting.stage === 'submitted') ||
            (addons.lite_motion && addons.lite_motion.stage === 'submitted') ||
            (addons.creative && addons.creative.stage === 'submitted'))
        ) {
          if (agencyUser) {
            statusObj.description = 'Please action client feedback/amends'
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = editInner
            statusObj.name = 'Natives'
          } else {
            statusObj.description = 'An expert is working on this'
            statusObj.outerClasses = inProgressOuter
            statusObj.innerClasses = inProgressInner
            statusObj.name = 'Natives'
          }
        } else if (
          tactic.stage === 'submitted' &&
          ((addons.copywriting && addons.copywriting.stage === 'submitted') ||
            (addons.lite_motion && addons.lite_motion.stage === 'submitted') ||
            (addons.creative && addons.creative.stage === 'submitted'))
        ) {
          if (!agencyUser) {
            statusObj.description = 'Creative Service ready to be reviewed'
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = alertInner
            statusObj.name = accountObj().name
          } else {
            statusObj.description = 'Client is reviewing this'
            statusObj.innerClasses = inProgressInner
            statusObj.outerClasses = inProgressOuter
            statusObj.name = accountObj().name
          }
        } else if (tactic.stage === 'media_review') {
          if (!agencyUser) {
            statusObj.description = 'Complete'
            statusObj.outerClasses = completeOuter
            statusObj.innerClasses = completeInner
            statusObj.name = ''
          } else {
            statusObj.description = 'Review media'
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = alertInner
            statusObj.name = ''
          }
        } else if (tactic.stage === 'complete') {
          statusObj.description = 'Complete'
          statusObj.outerClasses = completeOuter
          statusObj.innerClasses = completeInner
          statusObj.name = ''
        }
      } else if (
        tactic &&
        (tactic.stage === 'complete' ||
          tactic.stage === 'submitted' ||
          (tactic.stage === 'not_submitted' && tactic.quality !== null))
      ) {
        if (tactic.stage === 'complete') {
          statusObj.description = 'Complete'
          statusObj.outerClasses = completeOuter
          statusObj.innerClasses = completeInner
          statusObj.name = ''
        } else if (tactic.stage === 'submitted') {
          if (agencyUser) {
            statusObj.description = 'You need to review this'
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = alertInner
            statusObj.name = 'Natives'
          } else {
            statusObj.description = 'An expert is reviewing this'
            statusObj.outerClasses = inProgressOuter
            statusObj.innerClasses = inProgressInner
            statusObj.name = 'Natives'
          }
        } else if (
          tactic.stage === 'not_submitted' &&
          tactic.quality !== null
        ) {
          if (agencyUser) {
            statusObj.description = 'Client is reviewing this'
            statusObj.innerClasses = inProgressInner
            statusObj.outerClasses = inProgressOuter
            statusObj.name = 'Natives'
          } else {
            statusObj.description = 'You need to review this'
            statusObj.outerClasses = alertOuter
            statusObj.innerClasses = alertInner
            statusObj.name = accountObj().name
          }
        }
      } else {
        statusObj.description = 'Not needed for this tactic'
        statusObj.outerClasses = 'flex circle circle--medium'
        statusObj.innerClasses = 'icon-minus color-grey-light block'
        statusObj.name = ''
      }

      return statusObj
    }

    let status = getStatus(props.tacticSection, props.agencyUser)

    watch(
      () => props.tacticSection,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          status = getStatus(props.tacticSection, props.agencyUser)
        }
      },
    )

    return {
      status,
    }
  },
})
</script>
